/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActiveInvestmentRequestsCheckPayload,
  BatchInvestmentRequestCreatePayload,
  BatchInvestmentRequestCreateResponse,
  HTTPValidationError,
  InvestmentRequest,
  InvestmentRequestCreatePayload,
  InvestmentRequestUpdate,
  InvestmentRequestUpdatePayload,
} from '../models/index';
import {
    ActiveInvestmentRequestsCheckPayloadFromJSON,
    ActiveInvestmentRequestsCheckPayloadToJSON,
    BatchInvestmentRequestCreatePayloadFromJSON,
    BatchInvestmentRequestCreatePayloadToJSON,
    BatchInvestmentRequestCreateResponseFromJSON,
    BatchInvestmentRequestCreateResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    InvestmentRequestFromJSON,
    InvestmentRequestToJSON,
    InvestmentRequestCreatePayloadFromJSON,
    InvestmentRequestCreatePayloadToJSON,
    InvestmentRequestUpdateFromJSON,
    InvestmentRequestUpdateToJSON,
    InvestmentRequestUpdatePayloadFromJSON,
    InvestmentRequestUpdatePayloadToJSON,
} from '../models/index';

export interface ApiCheckOngoingRebalanceRequest {
    activeInvestmentRequestsCheckPayload: ActiveInvestmentRequestsCheckPayload;
}

export interface CreateInvestmentRequestRequest {
    investmentRequestCreatePayload: InvestmentRequestCreatePayload;
}

export interface CreateInvestmentRequestsBatchRequest {
    batchInvestmentRequestCreatePayload: BatchInvestmentRequestCreatePayload;
}

export interface GetInvestmentRequestUpdatesRequest {
    requestId: number;
}

export interface UpdateInvestmentRequestRequest {
    investmentRequestUpdatePayload: InvestmentRequestUpdatePayload;
}

/**
 * 
 */
export class InvestmentRequestApi extends runtime.BaseAPI {

    /**
     * Check which accounts have an ongoing investment request.
     */
    async apiCheckOngoingRebalanceRaw(requestParameters: ApiCheckOngoingRebalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: boolean; }>> {
        if (requestParameters.activeInvestmentRequestsCheckPayload === null || requestParameters.activeInvestmentRequestsCheckPayload === undefined) {
            throw new runtime.RequiredError('activeInvestmentRequestsCheckPayload','Required parameter requestParameters.activeInvestmentRequestsCheckPayload was null or undefined when calling apiCheckOngoingRebalance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/investment-request/ongoing-rebalance`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActiveInvestmentRequestsCheckPayloadToJSON(requestParameters.activeInvestmentRequestsCheckPayload),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Check which accounts have an ongoing investment request.
     */
    async apiCheckOngoingRebalance(requestParameters: ApiCheckOngoingRebalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: boolean; }> {
        const response = await this.apiCheckOngoingRebalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new investment request.
     */
    async createInvestmentRequestRaw(requestParameters: CreateInvestmentRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.investmentRequestCreatePayload === null || requestParameters.investmentRequestCreatePayload === undefined) {
            throw new runtime.RequiredError('investmentRequestCreatePayload','Required parameter requestParameters.investmentRequestCreatePayload was null or undefined when calling createInvestmentRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/investment-request/create`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentRequestCreatePayloadToJSON(requestParameters.investmentRequestCreatePayload),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create a new investment request.
     */
    async createInvestmentRequest(requestParameters: CreateInvestmentRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.createInvestmentRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a batch of investment requests.
     */
    async createInvestmentRequestsBatchRaw(requestParameters: CreateInvestmentRequestsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BatchInvestmentRequestCreateResponse>> {
        if (requestParameters.batchInvestmentRequestCreatePayload === null || requestParameters.batchInvestmentRequestCreatePayload === undefined) {
            throw new runtime.RequiredError('batchInvestmentRequestCreatePayload','Required parameter requestParameters.batchInvestmentRequestCreatePayload was null or undefined when calling createInvestmentRequestsBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/investment-request/create-batch`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BatchInvestmentRequestCreatePayloadToJSON(requestParameters.batchInvestmentRequestCreatePayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchInvestmentRequestCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create a batch of investment requests.
     */
    async createInvestmentRequestsBatch(requestParameters: CreateInvestmentRequestsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BatchInvestmentRequestCreateResponse> {
        const response = await this.createInvestmentRequestsBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get investment request updates.
     */
    async getInvestmentRequestUpdatesRaw(requestParameters: GetInvestmentRequestUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvestmentRequestUpdate>>> {
        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling getInvestmentRequestUpdates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/investment-request-update/get/{request_id}`.replace(`{${"request_id"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvestmentRequestUpdateFromJSON));
    }

    /**
     * Get investment request updates.
     */
    async getInvestmentRequestUpdates(requestParameters: GetInvestmentRequestUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvestmentRequestUpdate>> {
        const response = await this.getInvestmentRequestUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get investment requests.
     */
    async getInvestmentRequestsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvestmentRequest>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/investment-request/get`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvestmentRequestFromJSON));
    }

    /**
     * Get investment requests.
     */
    async getInvestmentRequests(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvestmentRequest>> {
        const response = await this.getInvestmentRequestsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update an investment request.
     */
    async updateInvestmentRequestRaw(requestParameters: UpdateInvestmentRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.investmentRequestUpdatePayload === null || requestParameters.investmentRequestUpdatePayload === undefined) {
            throw new runtime.RequiredError('investmentRequestUpdatePayload','Required parameter requestParameters.investmentRequestUpdatePayload was null or undefined when calling updateInvestmentRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/investment-request/update`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentRequestUpdatePayloadToJSON(requestParameters.investmentRequestUpdatePayload),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update an investment request.
     */
    async updateInvestmentRequest(requestParameters: UpdateInvestmentRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateInvestmentRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
